import React from 'react'
import background from '../../Assets/Hero/home_hero.png'

function Hero() {
    return (
        <div
            className="w-full bg-white"
        >
            <div className="mx-auto max-w-[1640px] lato z-10 relative py-[10rem] h-full flex items-center justify-end"
                style={{
                    backgroundImage: `url(${background})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    minHeight: 'auto',
                }}>
                <div className='w-[80%] md:w-[40%] text-right pr-[1rem] md:pr-[2rem]'>
                    <p
                        style={{ fontSize: 'clamp(30px,4.5vw,70px)' }}
                        className='text-white uppercase font-extrabold'>
                        Empowering your digital future
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Hero
